import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import GridItem from 'components/GridItem'
import SvgMap from 'components/SvgMap'
import ColorScale from 'components/ColorScale'
import alle from '../../data/1000-alle.json'
import fAlle from '../../data/500-f.json'
import mAlle from '../../data/500-m.json'
import jungAlle from '../../data/500-alle-jung.json'
import altAlle from '../../data/500-alle-alt.json'
import fJung from '../../data/250-f-jung.json'
import mJung from '../../data/250-m-jung.json'
import diffJung from '../../data/250-diff-jung.json'
import { title } from 'process'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    handleResize()
  }, [])

  const minColor = '#313695'
  const midColor = '#FFE462'
  const maxColor = '#a50026'

  const modules: { [key: string]: ReactElement } = {
    alle: (
      <div className='big-map'>
        <GridItem
          titleText={properties?.titleText || ''}
          data={alle}
          colorMode={colorMode}
          tenant={tenant}
          minColor={minColor}
          midColor={midColor}
          maxColor={maxColor}
          isBig={true}
          min={4.28}
          max={4.51}
        />
        <ColorScale
          data={alle}
          colorMode={colorMode}
          tenant={tenant}
          minColor={minColor}
          midColor={midColor}
          maxColor={maxColor}
          isBig={true}
          min={4.28}
          max={4.51}
          minTerm={'eher langsam'}
          maxTerm={'eher schnell'}
        />
      </div>
    ),
    fraumann: (
      <div className='comparison'>
        <div className='grid'>
          <GridItem
            titleText={properties?.titleText || ''}
            data={fAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.22}
            max={4.56}
          />

          {isMobile && (
            <ColorScale
              data={mAlle}
              colorMode={colorMode}
              tenant={tenant}
              minColor={minColor}
              midColor={midColor}
              maxColor={maxColor}
              min={4.22}
              max={4.56}
              minTerm={'eher langsam'}
              maxTerm={'eher schnell'}
            />
          )}

          <GridItem
            titleText={properties?.title2Text || ''}
            data={mAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.22}
            max={4.56}
          />
        </div>
        {!isMobile && (
          <ColorScale
            data={mAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.22}
            max={4.56}
            minTerm={'eher langsam'}
            maxTerm={'eher schnell'}
          />
        )}
      </div>
    ),
    jungalt: (
      <div className='comparison'>
        <div className='grid'>
          <GridItem
            titleText={properties?.titleText || ''}
            data={jungAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.24}
            max={4.53}
          />

          {isMobile && (
            <ColorScale
              data={jungAlle}
              colorMode={colorMode}
              tenant={tenant}
              minColor={minColor}
              midColor={midColor}
              maxColor={maxColor}
              min={4.24}
              max={4.53}
              minTerm={'eher langsam'}
              maxTerm={'eher schnell'}
            />
          )}

          <GridItem
            titleText={properties?.title2Text || ''}
            data={altAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.24}
            max={4.53}
          />
        </div>
        {!isMobile && (
          <ColorScale
            data={jungAlle}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.24}
            max={4.53}
            minTerm={'eher langsam'}
            maxTerm={'eher schnell'}
          />
        )}
      </div>
    ),
    junge: (
      <div className='comparison'>
        <div className='grid'>
          <GridItem
            titleText={properties?.titleText || ''}
            data={fJung}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.13}
            max={4.57}
          />

          {isMobile && (
            <ColorScale
              data={fJung}
              colorMode={colorMode}
              tenant={tenant}
              minColor={minColor}
              midColor={midColor}
              maxColor={maxColor}
              min={4.13}
              max={4.57}
              minTerm={'eher langsam'}
              maxTerm={'eher schnell'}
            />
          )}

          <GridItem
            titleText={properties?.title2Text || ''}
            data={mJung}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.13}
            max={4.57}
          />
        </div>
        {!isMobile && (
          <ColorScale
            data={fJung}
            colorMode={colorMode}
            tenant={tenant}
            minColor={minColor}
            midColor={midColor}
            maxColor={maxColor}
            min={4.13}
            max={4.57}
            minTerm={'eher langsam'}
            maxTerm={'eher schnell'}
          />
        )}
      </div>
    ),
    diffjunge: (
      <div className='small-map'>
        <GridItem
          titleText={properties?.titleText || ''}
          data={diffJung}
          colorMode={colorMode}
          tenant={tenant}
          minColor={colorMode === 'dark' ? '#675359' : '#dcc8cf'}
          maxColor={'#A757A3'}
          isBig={true}
          min={0.001}
          max={0.26}
        />
        <ColorScale
          data={diffJung}
          colorMode={colorMode}
          tenant={tenant}
          minColor={colorMode === 'dark' ? '#675359' : '#dcc8cf'}
          maxColor={'#A757A3'}
          isBig={true}
          min={0.001}
          max={0.26}
          minTerm={'kleine Differenz'}
          maxTerm={'grosse Differenz'}
        />
      </div>
    ),
  }
  return (
    <AppContainer $colorMode={colorMode}>
      {properties && <>{modules[properties.module]}</>}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  .comparison {
    margin: 2rem 0 0;
    @media only screen and (max-width: 600px) {
      margin: 0 0 2rem;
    }
    .grid {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto 0;
      grid-template-columns: 1fr 1fr;
      @media only screen and (max-width: 600px) {
        grid-template-columns: 1fr;
      }
      display: grid;
    }
  }
  .big-map {
    margin-bottom: 3rem;
  }
  .small-map {
    max-width: 600px;
    margin: 3rem auto 3rem;
    h4 {
      @media only screen and (min-width: 601px) {
        margin-bottom: 0;
      }
    }
  }
`
export default MainComponent
